const HisPeople = ({color, sx}) => {
  const strokeColor = color ?? '#708FBB';
  let _sx = sx ?? {};
  return (
    <svg style={_sx} width="22" height="20" viewBox="0 0 22 20" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path
        d="M15 19V17C15 15.9391 14.5786 14.9217 13.8284 14.1716C13.0783 13.4214 12.0609 13 11 13H5C3.93913 13 2.92172 13.4214 2.17157 14.1716C1.42143 14.9217 1 15.9391 1 17V19"
        stroke={strokeColor} stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
      <path d="M8 9C10.2091 9 12 7.20914 12 5C12 2.79086 10.2091 1 8 1C5.79086 1 4 2.79086 4 5C4 7.20914 5.79086 9 8 9Z"
            stroke={strokeColor} stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
      <path
        d="M21 18.9989V16.9989C20.9993 16.1126 20.7044 15.2517 20.1614 14.5512C19.6184 13.8508 18.8581 13.3505 18 13.1289"
        stroke={strokeColor} stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
      <path
        d="M15 1.12891C15.8604 1.34921 16.623 1.84961 17.1676 2.55122C17.7122 3.25283 18.0078 4.11574 18.0078 5.00391C18.0078 5.89208 17.7122 6.75499 17.1676 7.4566C16.623 8.1582 15.8604 8.65861 15 8.87891"
        stroke={strokeColor} stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
    </svg>
  )
}

export default HisPeople;